import React, { useState } from "react";
import { ReactComponent as ExcellentPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/Excellent_poop.svg";
import { ReactComponent as GoodPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/Good_poop.svg";
import { ReactComponent as HardPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/Hard_poop.svg";
import { ReactComponent as NoPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/No_poop.svg";
import { ReactComponent as PoorPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/Poor_poop.svg";
import { ReactComponent as SatisfactoryPoopIcon } from "../../../../../assects/svg/client_details/GUT_HEALTH/Satisfactory_poop.svg";
import { ReactComponent as ArrowUpRight } from "../../../../../assects/svg/client_details/ArrowUpRight.svg";
import Drawer from "./Drawer";
import { PoopCycle } from "../../../hooks/useAllLogsData";

interface GutHealthCardProps {
  poopCycle: PoopCycle[];
  selectedDate?: string;
}

const GutHealthCard: React.FC<GutHealthCardProps> = ({ poopCycle, selectedDate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const getPoopIcon = (mood: string) => {
    const iconMap: { [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> } = {
      Excellent: ExcellentPoopIcon,
      Good: GoodPoopIcon,
      Satisfactory: SatisfactoryPoopIcon,
      Hard: HardPoopIcon,
      Poor: PoorPoopIcon,
    };
    
    return iconMap[mood] || NoPoopIcon;
  };

  const formatTime = (hours: number, minutes: number, ampm: string): string => {
    const paddedHour = hours.toString().padStart(2, "0");
    const paddedMinute = minutes.toString().padStart(2, "0");
    return `${paddedHour}:${paddedMinute} ${ampm}`;
  };

  const renderPoopEntry = (entry: PoopCycle) => {
    const PoopIcon = getPoopIcon(entry.mood);
    const time = formatTime(entry.cycle_hours, entry.cycle_minutes, entry.ampm);
    
    return (
      <div className="flex items-center gap-2">
        <PoopIcon className="w-6 h-6 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
            {entry.mood}{" "}
            <span className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
              • {time}
            </span>
          </p>
          <p
  className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D] truncate"
  title={entry.comment || "no message"}
>
  {entry.comment || "no message"}
</p>
        </div>
      </div>
    );
  };

  const displayedEntries = poopCycle.slice(0, 2);

  if (!poopCycle || poopCycle.length === 0) {
    return (
      <div className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full">
        <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase mb-4">
          GUT HEALTH
        </h3>
        <div className="flex-1 flex items-center justify-center pb-4">
          <p className="text-sm font-medium text-[#646464] font-inter">No entries yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div onClick={() => setIsDrawerOpen(true)} className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full cursor-pointer">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            GUT HEALTH
          </h3>
          <button
            
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="View all gut health entries"
          >
            <ArrowUpRight className="w-4 h-4 3xl:w-5 3xl:h-5 text-[#1F1F1F]" />
          </button>
        </div>
        
        <div>
          {displayedEntries.map((entry, index) => (
            <React.Fragment key={entry.cycle_id || index}>
              {renderPoopEntry(entry)}
              {index < displayedEntries.length - 1 && (
                <div className="w-full border-t border-gray-200 my-2.5"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Gut Health"
        selectedDate={selectedDate}
      >
        <div className="space-y-3">
          {poopCycle.map((entry, index) => (
            <div key={entry.cycle_id || index} className="pb-3 border-b border-gray-100">
              {renderPoopEntry(entry)}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default GutHealthCard;